export default __webpack_public_path__ + "static/media/AirbnbCerealBook.d42c6a4d.woff";